// extracted by mini-css-extract-plugin
export default {"button":"klL7l","formButton":"byMcJ","form":"YyZjm","error":"z7gZE","summaryBlock":"HFZ6i","fullButton":"_9ndoT","title":"+Y39f"};